const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1c7a41d897e1d32e3dfc3afcfd689b69.jpg"
          alt="Equipo profesional de vaciado"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/70 via-dark/60 to-dark/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Main Content */}
          <div className="text-white space-y-6">
            {/* Badge */}
            <div className="inline-block">
              <span className="bg-secondary/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-xs sm:text-sm font-medium">
                Servicio 24h · El Prat de Llobregat
              </span>
            </div>

            {/* H1 - SEO Optimized */}
            <h1 className="space-y-2">
              <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight break-words">
                Vaciado de pisos
              </div>
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold break-words">
                y limpieza extrema
              </div>
              <div className="text-lg sm:text-xl md:text-2xl font-medium text-white/90 break-words">
                en El Prat de Llobregat
              </div>
            </h1>

            {/* Description */}
            <p className="text-base sm:text-lg md:text-xl text-white/85 max-w-2xl leading-relaxed">
              Especialistas en <strong>vaciado de pisos</strong>, <strong>vaciado de locales</strong> y <strong>limpieza por síndrome de Diógenes</strong>. Servicio discreto, rápido y profesional con más de 10 años de experiencia en <a href="https://www.elprat.cat/" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary transition-colors cursor-pointer">El Prat de Llobregat y Baix Llobregat</a>.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href="tel:+34602365996"
                className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-primary text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-opacity-90 transition-all shadow-lg hover:shadow-xl animate-pulse-soft cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl sm:text-2xl"></i>
                <span>Llamar Ahora</span>
              </a>
              <a
                href="https://wa.me/34602365996?text=Hola,%20me%20gustaría%20solicitar%20información"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 sm:gap-3 border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-white hover:text-dark transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
                <span>WhatsApp Gratis</span>
              </a>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-4 sm:gap-6 pt-6">
              <div className="flex items-center gap-2 text-xs sm:text-sm">
                <i className="ri-checkbox-circle-fill text-primary text-lg sm:text-xl flex-shrink-0"></i>
                <span>+10 años experiencia</span>
              </div>
              <div className="flex items-center gap-2 text-xs sm:text-sm">
                <i className="ri-checkbox-circle-fill text-primary text-lg sm:text-xl flex-shrink-0"></i>
                <span>+500 pisos vaciados</span>
              </div>
              <div className="flex items-center gap-2 text-xs sm:text-sm">
                <i className="ri-checkbox-circle-fill text-primary text-lg sm:text-xl flex-shrink-0"></i>
                <span>Presupuesto gratis</span>
              </div>
            </div>
          </div>

          {/* Right Column - Additional Visual Element */}
          <div className="hidden lg:block"></div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
